<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-xi"></a>
<h2 class="fmt"><span class="bold">Acknowledgments</span></h2>
<p class="noindent1"><span class="bold">Chief Historical Consultant</span></p>
<p class="noindent">Gyula Sárhidai</p>
<p class="noindent1"><span class="bold">Further Historical Consultants</span></p>
<p class="noindent">Tamás Baczoni</p>
<p class="noindent">Péter Bilik</p>
<p class="noindent">Antal Fejes</p>
<p class="noindent">Vladimír Francev</p>
<p class="noindent">Dr. Zoltán András Kovács</p>
<p class="noindent">Dr. Imre Domokos Nagy</p>
<p class="noindent">Břetislav Nakládal</p>
<p class="noindent">Kamen Nevenkin</p>
<p class="noindent">Leo W.G. Niehorster</p>
<p class="noindent">György Punka</p>
<p class="noindent">Jiří Tintěra</p>
<p class="noindent">Jaroslav Tvrdý</p>
<p class="noindent">Ferenc-Antal Vajda</p>
<p class="noindent">Péter Zámbori</p>
<p class="noindent1"><span class="bold">Further Acknowledgments</span></p>
<p class="noindent">Iván Bajtos (deceased)</p>
<p class="noindent">Lajos Berényi</p>
<p class="noindent">Aldo Carrer</p>
<p class="noindent">Zsolt Dávid</p>
<p class="noindent">Henry Hoppe</p>
<p class="noindent">Márton László</p>
<p class="noindent">Gerald Mlynek</p>
<p class="noindent">Dr. Péter Mujzer</p>
<a id="VPS-xii"></a>
<p class="noindent1"><span class="bold">Photo Credits</span></p>
<p class="noindent">Most of the photographs in this book come from the authors’ personal collections.</p>
<p class="noindent">Other contributors:</p>
<p class="noindent">Balázs Almási</p>
<p class="noindent">Péter Bilik</p>
<p class="noindent">Aldo Carrer</p>
<p class="noindent">Fortepan Team (especially Miklós Tamási)</p>
<p class="noindent">Miklós Éder</p>
<p class="noindent">Antal Gerencsér</p>
<p class="noindent">Andor Gibás (deceased)</p>
<p class="noindent">Andrew Hennessy (formerly Endre Hitesi) (deceased)</p>
<p class="noindent">László Hemmert</p>
<p class="noindent">Henry Hoppe</p>
<p class="noindent">László Jávor</p>
<p class="noindent">László</p>
<p class="noindent">Zoltán Lakos</p>
<p class="noindent">Tony Latoche (deceased)</p>
<p class="noindent">Dr. Péter Mujzer</p>
<p class="noindent">Dr. József Németh</p>
<p class="noindent">Kamen Nevenkin</p>
<p class="noindent">Attila Palotai</p>
<p class="noindent">György Punka</p>
<p class="noindent">Gyula Sárhidai</p>
<p class="noindent">Sándor Sarkady jr.</p>
<p class="noindent">Andor Szeltner</p>
<p class="noindent">Ferenc Szeverényi</p>
<p class="noindent">Zoltán Tálosi</p>
<p class="noindent">Patrik Ungár</p>
<p class="noindent">László Winkler (deceased)</p>
<p class="noindent">Károly Zajtai</p>
<p class="noindent">Péter Zákányi</p>
<p class="noindent">Lutz Zours-Konetzny</p>
<p class="noindent1">Archives of <em class="italic">Haditechnica</em> military periodical</p>
<p class="noindenth">Archives of <em class="italic">Hadtörténeti Intézet és Múzeum</em> (Institute and Museum of Military History)</p>
<p class="noindenth">Archives of the (defunct) <em class="italic">Kanadai Magyar Szárnyak</em> (Hungarian Wings of Canada)</p>
<p class="noindenth">Archives of the (defunct) <em class="italic">Magyar Munkásmozgalmi Múzeum</em> (Museum of Hungarian Workers’ Movement)</p>
<p class="noindenth">Archives and publications of the (defunct) ‘MKCSBK’ Hungarian Veterans (Canada) Archives and publications of the (defunct) <em class="italic">Vitézi Rend</em> and ‘MHBK’ (Germany)</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?a1e5e37e